module.exports = __webpack_public_path__ + "files/7ac1bc64406703e2494f7103b37a0ffe.png";